import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { IEvent, IHotel } from "../../../interfaces/models/IEvent";
import Close from "../../../components/Atomos/Icons/Close";
import SaveChanges from "../../../components/Atomos/Icons/EditMode/SaveChanges";
import LegacyButton from "../../../components/Atomos/Buttons/LegacyButton";
import ChevronDown from "../../../components/Atomos/Icons/ChevronDown";
import DeleteTrashIcon from "../../../assets/images&icons/delete-trash-icon.svg";
import Input from "../../../components/Atomos/Inputs/Input";
import InputImage from "../../../components/Atomos/InputImage/InputImage";
import { updateEvent, getEventById } from "../../../Services/Event";
import { toastError, toastPromise } from "../../../utils/toast";
import { uploadImage } from "../../../utils/UploadImage";
import { NewEvent } from "../../../redux/states/event.state";
import MemberAccomodationsTabPreview from "./MemberAccomodationsTab";
import "../Events.css";
import "../../../assets/css/Text.css";
import { CURRENCY_OPTIONS } from "../../../utils/const";


const HotelFormSeparator = () => (
  <div className="w-full border-t border-[#CCCCCC] !mt-10 !mb-10"></div>
);


export default function MemberAccomodationsTab({
  event,
  isEditMode: externalIsEditMode,
  onEditClick,
  onEventUpdate,
}: {
  event: IEvent | null;
  isEditMode?: boolean;
  onEditClick?: () => void;
  onEventUpdate?: (updatedEvent: IEvent) => void;
}) {
  const dispatch = useDispatch();
  const isEditMode =
    externalIsEditMode !== undefined ? externalIsEditMode : false;
  const [descriptionLengths, setDescriptionLengths] = useState<{
    [key: number]: number;
  }>({});
  const [hotelDescriptions, setHotelDescriptions] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelIds, setNewHotelIds] = useState<number[]>([]);
  const [newHotelCounter, setNewHotelCounter] = useState(0);
  const [newHotelDescriptionLengths, setNewHotelDescriptionLengths] = useState<{
    [key: number]: number;
  }>({});
  const [newHotelDescriptions, setNewHotelDescriptions] = useState<{
    [key: number]: string;
  }>({});
  const [validationErrors, setValidationErrors] = useState<{
    [key: number]: { [field: string]: boolean };
  }>({});
  const [newHotelValidationErrors, setNewHotelValidationErrors] = useState<{
    [key: number]: { [field: string]: boolean };
  }>({});
  const [newHotelImages, setNewHotelImages] = useState<{
    [key: number]: string | null;
  }>({});
  const [hotelImageFiles, setHotelImageFiles] = useState<{
    [key: number]: File | null;
  }>({});
  const [hotelImagePreviews, setHotelImagePreviews] = useState<{
    [key: number]: string | null;
  }>({});
  const [newHotelImageFiles, setNewHotelImageFiles] = useState<{
    [key: number]: File | null;
  }>({});
  const [newHotelImagePreviews, setNewHotelImagePreviews] = useState<{
    [key: number]: string | null;
  }>({});

  const [hotelNames, setHotelNames] = useState<{ [key: number]: string }>({});
  const [hotelAddresses, setHotelAddresses] = useState<{
    [key: number]: string;
  }>({});
  const [hotelWebsiteLinks, setHotelWebsiteLinks] = useState<{
    [key: number]: string;
  }>({});
  const [hotelReservationLinks, setHotelReservationLinks] = useState<{
    [key: number]: string;
  }>({});
  const [hotelSectionTitles, setHotelSectionTitles] = useState<{
    [key: number]: string;
  }>({});
  const [hotelRoomTypes, setHotelRoomTypes] = useState<{
    [key: number]: string;
  }>({});
  const [hotelRoomRates, setHotelRoomRates] = useState<{
    [key: number]: string;
  }>({});
  const [hotelCurrencies, setHotelCurrencies] = useState<{
    [key: number]: string;
  }>({});

  const [newHotelNames, setNewHotelNames] = useState<{ [key: number]: string }>(
    {}
  );
  const [newHotelAddresses, setNewHotelAddresses] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelWebsiteLinks, setNewHotelWebsiteLinks] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelReservationLinks, setNewHotelReservationLinks] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelSectionTitles, setNewHotelSectionTitles] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelRoomTypes, setNewHotelRoomTypes] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelRoomRates, setNewHotelRoomRates] = useState<{
    [key: number]: string;
  }>({});
  const [newHotelCurrencies, setNewHotelCurrencies] = useState<{
    [key: number]: string;
  }>({});
  const [deletedHotelIndices, setDeletedHotelIndices] = useState<Set<number>>(
    new Set()
  );

  const sortedHotels =
    event && Array.isArray(event.accomodation) && event.accomodation.length > 0
      ? [...event.accomodation].sort((a, b) =>
          a.primary === b.primary ? 0 : a.primary ? -1 : 1
        )
      : [];

  useEffect(() => {
    if (event?.accomodation && event.accomodation.length > 0 && isEditMode) {
      const sorted = [...event.accomodation].sort((a, b) =>
        a.primary === b.primary ? 0 : a.primary ? -1 : 1
      );
      const descriptions: { [key: number]: string } = {};
      const lengths: { [key: number]: number } = {};
      const sectionTitles: { [key: number]: string } = {};
      const roomTypes: { [key: number]: string } = {};
      const roomRates: { [key: number]: string } = {};
      const currencies: { [key: number]: string } = {};
      sorted.forEach((hotel, index) => {
        if (hotel.description) {
          descriptions[index] = hotel.description;
          lengths[index] = hotel.description.length;
        }
        if ((hotel as any).sectionTitle) {
          sectionTitles[index] = (hotel as any).sectionTitle;
        }
        if ((hotel as any).roomType) {
          roomTypes[index] = (hotel as any).roomType;
        }
        if ((hotel as any).roomRate) {
          roomRates[index] = (hotel as any).roomRate;
        }
        if ((hotel as any).currency) {
          currencies[index] = (hotel as any).currency;
        }
      });
      setHotelDescriptions(descriptions);
      setDescriptionLengths(lengths);
      setHotelSectionTitles(sectionTitles);
      setHotelRoomTypes(roomTypes);
      setHotelRoomRates(roomRates);
      setHotelCurrencies(currencies);
    }
  }, [event?.accomodation, isEditMode]);

  if (!event) {
    return <div>Event not found</div>;
  }

  const handleImageSet = (
    image: string | File | null,
    index: number,
    isNewHotel: boolean = false
  ) => {
    if (isNewHotel) {
      if (image instanceof File) {
        setNewHotelImageFiles({ ...newHotelImageFiles, [index]: image });
        const reader = new FileReader();
        reader.onloadend = () => {
          const previewUrl = reader.result as string;
          setNewHotelImagePreviews({
            ...newHotelImagePreviews,
            [index]: previewUrl,
          });
        };
        reader.readAsDataURL(image);
      } else if (typeof image === "string") {
        setNewHotelImages({ ...newHotelImages, [index]: image });
        setNewHotelImagePreviews({ ...newHotelImagePreviews, [index]: image });
      } else {
        setNewHotelImageFiles({ ...newHotelImageFiles, [index]: null });
        setNewHotelImagePreviews({ ...newHotelImagePreviews, [index]: null });
        setNewHotelImages({ ...newHotelImages, [index]: null });
      }
      if (newHotelValidationErrors[index]?.image) {
        setNewHotelValidationErrors({
          ...newHotelValidationErrors,
          [index]: { ...newHotelValidationErrors[index], image: false },
        });
      }
    } else {
      if (image instanceof File) {
        setHotelImageFiles({ ...hotelImageFiles, [index]: image });
        const reader = new FileReader();
        reader.onloadend = () => {
          const previewUrl = reader.result as string;
          setHotelImagePreviews({ ...hotelImagePreviews, [index]: previewUrl });
        };
        reader.readAsDataURL(image);
      } else if (typeof image === "string") {
        setHotelImagePreviews({ ...hotelImagePreviews, [index]: image });
      } else {
        setHotelImageFiles({ ...hotelImageFiles, [index]: null });
        setHotelImagePreviews({ ...hotelImagePreviews, [index]: null });
      }
      if (validationErrors[index]?.image) {
        setValidationErrors({
          ...validationErrors,
          [index]: { ...validationErrors[index], image: false },
        });
      }
    }
  };

  const validateHotel = (validateErrors: {
    name: string;
    address: string;
    websiteLink: string;
    reservationLink: string;
    image: string | null | File;
  }): { [field: string]: boolean } => {
    const { name, address, websiteLink, image } =
      validateErrors;
    const errors: { [field: string]: boolean } = {};
    if (!name || name.trim() === "") {
      errors.name = true;
    }
    if (!address || address.trim() === "") {
      errors.address = true;
    }
    if (!websiteLink || websiteLink.trim() === "") {
      errors.websiteLink = true;
    }
    if (!image) {
      errors.image = true;
    }
    return errors;
  };

  const getHotelFormData = (index: number) => {
    const hotel = sortedHotels[index];
    const isDeleted = deletedHotelIndices.has(index);
    
    const aliveHotelsCount = sortedHotels.filter(
      (_, idx) => !deletedHotelIndices.has(idx)
    ).length;
    
    const displayHotel = isDeleted && aliveHotelsCount === 0 ? null : hotel;
    
    return {
      name: hotelNames[index] ?? displayHotel?.name ?? "",
      address: hotelAddresses[index] ?? displayHotel?.address ?? "",
      websiteLink: hotelWebsiteLinks[index] ?? displayHotel?.url ?? "",
      reservationLink: hotelReservationLinks[index] ?? displayHotel?.reservationUrl ?? "",
    };
  };

  const handleAddNewHotel = () => {
    const newId = newHotelCounter;
    setNewHotelIds([...newHotelIds, newId]);
    setNewHotelCounter(newId + 1);
    setNewHotelImages({ ...newHotelImages, [newId]: null });
    setNewHotelImageFiles({ ...newHotelImageFiles, [newId]: null });
    setNewHotelImagePreviews({ ...newHotelImagePreviews, [newId]: null });
  };

  const handleCancelAllHotels = () => {
    setValidationErrors({});
    setNewHotelIds([]);
    setNewHotelValidationErrors({});
    setNewHotelDescriptionLengths({});
    setNewHotelImages({});
    setHotelImageFiles({});
    setHotelImagePreviews({});
    setNewHotelImageFiles({});
    setNewHotelImagePreviews({});

    setHotelNames({});
    setHotelAddresses({});
    setHotelWebsiteLinks({});
    setHotelReservationLinks({});
    setHotelSectionTitles({});
    setHotelRoomTypes({});
    setHotelRoomRates({});
    setHotelDescriptions({});
    setDescriptionLengths({});

    setNewHotelNames({});
    setNewHotelAddresses({});
    setNewHotelWebsiteLinks({});
    setNewHotelReservationLinks({});
    setNewHotelSectionTitles({});
    setNewHotelRoomTypes({});
    setNewHotelRoomRates({});
    setNewHotelCurrencies({});
    setNewHotelDescriptions({});
    
    setDeletedHotelIndices(new Set());
    
    if (onEditClick) {
      onEditClick();
    }
  };

  const handleSaveAllHotels = async () => {
    if (!event || !event.id) {
      toastError("Event ID is required to save changes");
      return;
    }

    const eventId = event.id;
    const savePromise = (async () => {
      const allErrors: { [key: number]: { [field: string]: boolean } } = {};
      const newHotelErrors: { [key: number]: { [field: string]: boolean } } = {};

      sortedHotels.forEach((hotel, index) => {
        if (deletedHotelIndices.has(index)) {
          return;
        }
        const formData = getHotelFormData(index);
        const imageForValidation = hotelImageFiles[index] || hotel.image || null;
        const errors = validateHotel({
          name: formData.name,
          address: formData.address,
          websiteLink: formData.websiteLink,
          reservationLink: formData.reservationLink,
          image: imageForValidation,
        });

        if (Object.keys(errors).length > 0) {
          allErrors[index] = errors;
        }
      });

      newHotelIds.forEach((newHotelId) => {
        const formData = {
          name: newHotelNames[newHotelId] || "",
          address: newHotelAddresses[newHotelId] || "",
          websiteLink: newHotelWebsiteLinks[newHotelId] || "",
          reservationLink: newHotelReservationLinks[newHotelId] || "",
        };
        const imageForValidation =
          newHotelImageFiles[newHotelId] || newHotelImages[newHotelId] || null;
        const errors = validateHotel({ ...formData, image: imageForValidation });

        if (Object.keys(errors).length > 0) {
          newHotelErrors[newHotelId] = errors;
        }
      });

      setValidationErrors(allErrors);
      setNewHotelValidationErrors(newHotelErrors);

      if (
        Object.keys(allErrors).length > 0 ||
        Object.keys(newHotelErrors).length > 0
      ) {
        throw new Error("Please fix validation errors before saving");
      }
      const accommodations: IHotel[] = [];

      for (let index = 0; index < sortedHotels.length; index++) {
        if (deletedHotelIndices.has(index)) {
          continue;
        }
        
        const hotel = sortedHotels[index];
        const formData = getHotelFormData(index);
        
        let imageUrl = hotel.image || "";
        if (hotelImageFiles[index]) {
          const uploadedUrl = await uploadImage(
            hotelImageFiles[index]!,
            eventId,
            "event/accommodations/"
          );
          if (uploadedUrl) {
            imageUrl = uploadedUrl;
          }
        }

        const roomType = hotelRoomTypes[index] ?? "";
        const roomRate = hotelRoomRates[index] ?? "";
        const currency = hotelCurrencies[index] ?? "";
        const sectionTitle = hotelSectionTitles[index] ?? "";
        const existingRate = hotel.rate ?? "";
        
        const rate = 
          (roomType && roomRate && `${roomType} - ${roomRate}${currency ? ` ${currency}` : ""}`) ||
          (roomRate && currency && `${roomRate} ${currency}`) ||
          roomRate ||
          roomType ||
          existingRate;

        accommodations.push({
          primary: hotel.primary || false,
          name: formData.name,
          address: formData.address,
          url: formData.websiteLink || "",
          reservationUrl: formData.reservationLink || undefined,
          image: imageUrl,
          description: hotelDescriptions[index] ?? hotel.description ?? "",
          rate: rate || undefined,
          sectionTitle: sectionTitle || undefined,
          roomType: roomType || undefined,
          roomRate: roomRate || undefined,
          currency: currency || undefined,
        } as any);
      }

      for (const newHotelId of newHotelIds) {
        let imageUrl = newHotelImages[newHotelId] || "";
        if (newHotelImageFiles[newHotelId]) {
          const uploadedUrl = await uploadImage(
            newHotelImageFiles[newHotelId]!,
            eventId,
            "event/accommodations/"
          );
          if (uploadedUrl) {
            imageUrl = uploadedUrl;
          }
        }

        const roomType = newHotelRoomTypes[newHotelId] || "";
        const roomRate = newHotelRoomRates[newHotelId] || "";
        const currency = newHotelCurrencies[newHotelId] || "";
        const sectionTitle = newHotelSectionTitles[newHotelId] || "";
        
        const rate = 
          (roomType && roomRate && `${roomType} - ${roomRate}${currency ? ` ${currency}` : ""}`) ||
          (roomRate && currency && `${roomRate} ${currency}`) ||
          roomRate ||
          roomType ||
          undefined;

        accommodations.push({
          primary: false,
          name: newHotelNames[newHotelId] || "",
          address: newHotelAddresses[newHotelId] || "",
          url: newHotelWebsiteLinks[newHotelId] || "",
          reservationUrl: newHotelReservationLinks[newHotelId] || undefined,
          image: imageUrl,
          description: newHotelDescriptions[newHotelId] || "",
          rate: rate,
          sectionTitle: sectionTitle || undefined,
          roomType: roomType || undefined,
          roomRate: roomRate || undefined,
          currency: currency || undefined,
        } as any);
      }

      const updatedEvent: IEvent = {
        ...event,
        accomodation: accommodations,
      };

      await updateEvent(updatedEvent);

      const reloadedEvent = await getEventById(eventId);
      
      if (reloadedEvent) {
        dispatch(NewEvent(reloadedEvent));
        
        if (onEventUpdate) {
          onEventUpdate(reloadedEvent);
        }
      }

      setNewHotelIds([]);
      setNewHotelValidationErrors({});
      setNewHotelDescriptionLengths({});
      setNewHotelImages({});
      setNewHotelImageFiles({});
      setNewHotelImagePreviews({});
      setNewHotelNames({});
      setNewHotelAddresses({});
      setNewHotelWebsiteLinks({});
      setNewHotelReservationLinks({});
      setNewHotelSectionTitles({});
      setNewHotelRoomTypes({});
      setNewHotelRoomRates({});
      setNewHotelCurrencies({});
      setNewHotelDescriptions({});
      
      setDeletedHotelIndices(new Set());

      if (onEditClick) {
        onEditClick();
      }
    })();

    try {
      await toastPromise(savePromise, {
        pending: "Saving accommodation data...",
        success: "Accommodation data saved successfully!",
        error: "Failed to save accommodation data",
      });
    } catch (error) {
      console.error(error);
      toastError(error as string);
    }
  };

  const clearValidationError = (
    index: number,
    field: string,
    isNewHotel: boolean = false
  ) => {
    if (isNewHotel) {
      if (newHotelValidationErrors[index]?.[field]) {
        setNewHotelValidationErrors({
          ...newHotelValidationErrors,
          [index]: {
            ...newHotelValidationErrors[index],
            [field]: false,
          },
        });
      }
    } else {
      if (validationErrors[index]?.[field]) {
        setValidationErrors({
          ...validationErrors,
          [index]: {
            ...validationErrors[index],
            [field]: false,
          },
        });
      }
    }
  };

  const handleHotelNameChange = (index: number, value: string) => {
    setHotelNames({ ...hotelNames, [index]: value });
    if (value) {
      clearValidationError(index, "name", false);
    }
  };

  const handleHotelAddressChange = (index: number, value: string) => {
    setHotelAddresses({ ...hotelAddresses, [index]: value });
    if (value) {
      clearValidationError(index, "address", false);
    }
  };

  const handleHotelWebsiteLinkChange = (index: number, value: string) => {
    setHotelWebsiteLinks({ ...hotelWebsiteLinks, [index]: value });
    if (value) {
      clearValidationError(index, "websiteLink", false);
    }
  };

  const handleHotelReservationLinkChange = (index: number, value: string) => {
    setHotelReservationLinks({ ...hotelReservationLinks, [index]: value });
    if (value) {
      clearValidationError(index, "reservationLink", false);
    }
  };

  const handleHotelSectionTitleChange = (index: number, value: string) => {
    setHotelSectionTitles({ ...hotelSectionTitles, [index]: value });
  };

  const handleHotelDescriptionChange = (index: number, value: string) => {
    setHotelDescriptions({ ...hotelDescriptions, [index]: value });
    setDescriptionLengths({
      ...descriptionLengths,
      [index]: value.length,
    });
  };

  const handleHotelRoomTypeChange = (index: number, value: string) => {
    setHotelRoomTypes({ ...hotelRoomTypes, [index]: value });
  };

  const handleHotelRoomRateChange = (index: number, value: string) => {
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue === '' || parseInt(numericValue, 10) > 0) {
      setHotelRoomRates({ ...hotelRoomRates, [index]: numericValue });
    }
  };

  const handleHotelCurrencyChange = (index: number, value: string) => {
    setHotelCurrencies({ ...hotelCurrencies, [index]: value });
  };

  const handleNewHotelNameChange = (newHotelId: number, value: string) => {
    setNewHotelNames({ ...newHotelNames, [newHotelId]: value });
    if (value) {
      clearValidationError(newHotelId, "name", true);
    }
  };

  const handleNewHotelAddressChange = (newHotelId: number, value: string) => {
    setNewHotelAddresses({ ...newHotelAddresses, [newHotelId]: value });
    if (value) {
      clearValidationError(newHotelId, "address", true);
    }
  };

  const handleNewHotelWebsiteLinkChange = (
    newHotelId: number,
    value: string
  ) => {
    setNewHotelWebsiteLinks({ ...newHotelWebsiteLinks, [newHotelId]: value });
    if (value) {
      clearValidationError(newHotelId, "websiteLink", true);
    }
  };

  const handleNewHotelReservationLinkChange = (
    newHotelId: number,
    value: string
  ) => {
    setNewHotelReservationLinks({
      ...newHotelReservationLinks,
      [newHotelId]: value,
    });
    if (value) {
      clearValidationError(newHotelId, "reservationLink", true);
    }
  };

  const handleNewHotelSectionTitleChange = (
    newHotelId: number,
    value: string
  ) => {
    setNewHotelSectionTitles({ ...newHotelSectionTitles, [newHotelId]: value });
  };

  const handleNewHotelDescriptionChange = (
    newHotelId: number,
    value: string
  ) => {
    setNewHotelDescriptions({ ...newHotelDescriptions, [newHotelId]: value });
    setNewHotelDescriptionLengths({
      ...newHotelDescriptionLengths,
      [newHotelId]: value.length,
    });
  };

  const handleNewHotelRoomTypeChange = (newHotelId: number, value: string) => {
    setNewHotelRoomTypes({ ...newHotelRoomTypes, [newHotelId]: value });
  };

  const handleNewHotelRoomRateChange = (newHotelId: number, value: string) => {
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue === '' || parseInt(numericValue, 10) > 0) {
      setNewHotelRoomRates({ ...newHotelRoomRates, [newHotelId]: numericValue });
    }
  };

  const handleNewHotelCurrencyChange = (newHotelId: number, value: string) => {
    setNewHotelCurrencies({ ...newHotelCurrencies, [newHotelId]: value });
  };

  const handleRemoveHotel = (index: number) => {
    const hotel = sortedHotels[index];
    const isAlreadyDeleted = deletedHotelIndices.has(index);
    
    const hasStateData =
      (hotelNames[index] && hotelNames[index].trim() !== "") ||
      (hotelAddresses[index] && hotelAddresses[index].trim() !== "") ||
      (hotelWebsiteLinks[index] && hotelWebsiteLinks[index].trim() !== "") ||
      (hotelReservationLinks[index] && hotelReservationLinks[index].trim() !== "") ||
      (hotelSectionTitles[index] && hotelSectionTitles[index].trim() !== "") ||
      (hotelDescriptions[index] && hotelDescriptions[index].trim() !== "") ||
      (hotelRoomTypes[index] && hotelRoomTypes[index].trim() !== "") ||
      (hotelRoomRates[index] && hotelRoomRates[index].trim() !== "") ||
      (hotelCurrencies[index] && hotelCurrencies[index].trim() !== "") ||
      hotelImageFiles[index] ||
      (hotelImagePreviews[index] && hotelImagePreviews[index] !== "");
    
    const hasOriginalData = !isAlreadyDeleted && (
      (hotel?.name && hotel.name.trim() !== "") ||
      (hotel?.address && hotel.address.trim() !== "") ||
      (hotel?.url && hotel.url.trim() !== "") ||
      (hotel?.description && hotel.description.trim() !== "") ||
      (hotel?.image && hotel.image.trim() !== "") ||
      (hotel as any)?.sectionTitle ||
      (hotel as any)?.roomType ||
      (hotel as any)?.roomRate ||
      (hotel as any)?.currency
    );
    
    const isStateExplicitlyCleared = 
      (hotelNames[index] === "" || hotelAddresses[index] === "" || 
       hotelWebsiteLinks[index] === "" || hotelReservationLinks[index] === "" ||
       hotelImagePreviews[index] === "");
    
    const hasData = hasStateData || (hasOriginalData && !isStateExplicitlyCleared);

    if (hasData) {
      setHotelNames((prev) => ({ ...prev, [index]: "" }));
      setHotelAddresses((prev) => ({ ...prev, [index]: "" }));
      setHotelWebsiteLinks((prev) => ({ ...prev, [index]: "" }));
      setHotelReservationLinks((prev) => ({ ...prev, [index]: "" }));
      setHotelSectionTitles((prev) => ({ ...prev, [index]: "" }));
      setHotelDescriptions((prev) => ({ ...prev, [index]: "" }));
      setDescriptionLengths((prev) => ({ ...prev, [index]: 0 }));
      setHotelRoomTypes((prev) => ({ ...prev, [index]: "" }));
      setHotelRoomRates((prev) => ({ ...prev, [index]: "" }));
      setHotelCurrencies((prev) => ({ ...prev, [index]: "" }));
      setHotelImageFiles((prev) => ({ ...prev, [index]: null }));
      setHotelImagePreviews((prev) => ({ ...prev, [index]: "" }));
      setValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
    } else {
      setDeletedHotelIndices((prev) => new Set(prev).add(index));
      setValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelNames((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelAddresses((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelWebsiteLinks((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelReservationLinks((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelSectionTitles((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelRoomTypes((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelRoomRates((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelCurrencies((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelDescriptions((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setDescriptionLengths((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelImageFiles((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setHotelImagePreviews((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
    }
  };

  const handleRemoveNewHotel = (newHotelId: number) => {
    const hasData =
      (newHotelNames[newHotelId] && newHotelNames[newHotelId].trim() !== "") ||
      (newHotelAddresses[newHotelId] && newHotelAddresses[newHotelId].trim() !== "") ||
      (newHotelWebsiteLinks[newHotelId] && newHotelWebsiteLinks[newHotelId].trim() !== "") ||
      (newHotelReservationLinks[newHotelId] && newHotelReservationLinks[newHotelId].trim() !== "") ||
      (newHotelSectionTitles[newHotelId] && newHotelSectionTitles[newHotelId].trim() !== "") ||
      (newHotelDescriptions[newHotelId] && newHotelDescriptions[newHotelId].trim() !== "") ||
      (newHotelRoomTypes[newHotelId] && newHotelRoomTypes[newHotelId].trim() !== "") ||
      (newHotelRoomRates[newHotelId] && newHotelRoomRates[newHotelId].trim() !== "") ||
      (newHotelCurrencies[newHotelId] && newHotelCurrencies[newHotelId].trim() !== "") ||
      newHotelImages[newHotelId] ||
      newHotelImageFiles[newHotelId];

    if (hasData) {
      setNewHotelNames((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelAddresses((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelWebsiteLinks((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelReservationLinks((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelSectionTitles((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelDescriptions((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelDescriptionLengths((prev) => ({ ...prev, [newHotelId]: 0 }));
      setNewHotelRoomTypes((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelRoomRates((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelCurrencies((prev) => ({ ...prev, [newHotelId]: "" }));
      setNewHotelImages((prev) => ({ ...prev, [newHotelId]: null }));
      setNewHotelImageFiles((prev) => ({ ...prev, [newHotelId]: null }));
      setNewHotelImagePreviews((prev) => ({ ...prev, [newHotelId]: null }));
      setNewHotelValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
    } else {
      setNewHotelIds((prev) => prev.filter((id) => id !== newHotelId));
      setNewHotelNames((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelAddresses((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelWebsiteLinks((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelReservationLinks((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelSectionTitles((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelDescriptions((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelDescriptionLengths((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelRoomTypes((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelRoomRates((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelCurrencies((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelImages((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelImageFiles((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelImagePreviews((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
      setNewHotelValidationErrors((prev) => {
        const updated = { ...prev };
        delete updated[newHotelId];
        return updated;
      });
    }
  };

  return (
    <>
      {!isEditMode ? (
        <MemberAccomodationsTabPreview />
      ) : (
        <div className="space-y-6">
          {sortedHotels.length > 0 ? (
            (() => {
              return sortedHotels.map((hotel, index) => {
                const isDeleted = deletedHotelIndices.has(index);
                
                if (isDeleted) {
                  return null;
                }
                
                const displayHotel = hotel;
              
              return (
                <div key={index} className="space-y-6">
                  <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex-1 space-y-4">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <Input
                            title="Hotel Name"
                            required={true}
                            name={`hotel-name-${index}`}
                            value={hotelNames[index] ?? displayHotel?.name ?? ""}
                            onChange={(e) =>
                              handleHotelNameChange(index, e.target.value)
                            }
                            error={validationErrors[index]?.name || false}
                            errorMsj={
                              validationErrors[index]?.name
                                ? "The Hotel Name is required."
                                : undefined
                            }
                          />
                        </div>
                        <div>
                          <Input
                            title="Address"
                            required={true}
                            name={`hotel-address-${index}`}
                            value={hotelAddresses[index] ?? displayHotel?.address ?? ""}
                            onChange={(e) =>
                              handleHotelAddressChange(index, e.target.value)
                            }
                            error={validationErrors[index]?.address || false}
                            errorMsj={
                              validationErrors[index]?.address
                                ? "The Address is required."
                                : undefined
                            }
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <Input
                            title="Website Link"
                            required={true}
                            name={`hotel-website-${index}`}
                            value={hotelWebsiteLinks[index] ?? displayHotel?.url ?? ""}
                            onChange={(e) =>
                              handleHotelWebsiteLinkChange(
                                index,
                                e.target.value
                              )
                            }
                            error={
                              validationErrors[index]?.websiteLink || false
                            }
                            errorMsj={
                              validationErrors[index]?.websiteLink
                                ? "The Website Link is required."
                                : undefined
                            }
                          />
                        </div>
                        <div>
                          <Input
                            title="Hotel Reservation Link"
                            required={false}
                            name={`hotel-reservation-${index}`}
                            value={
                              hotelReservationLinks[index] ?? displayHotel.reservationUrl ?? ""
                            }
                            onChange={(e) =>
                              handleHotelReservationLinkChange(
                                index,
                                e.target.value
                              )
                            }
                            error={false}
                          />
                        </div>
                      </div>
                      <div>
                        <Input
                          title="Section Title"
                          required={false}
                          name={`hotel-section-title-${index}`}
                          value={hotelSectionTitles[index] ?? ""}
                          onChange={(e) =>
                            handleHotelSectionTitleChange(index, e.target.value)
                          }
                          error={false}
                        />
                      </div>
                      <div className="flex flex-col gap-2.5 self-stretch items-start">
                        <label className="inputLabel text-gray-font">
                          Hotel Description
                        </label>
                        <textarea
                          value={hotelDescriptions[index] ?? displayHotel?.description ?? ""}
                          rows={4}
                          maxLength={1000}
                          onChange={(e) =>
                            handleHotelDescriptionChange(
                              index,
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 bg-[#F5F5F5] text-gray-900 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                        />
                        <div className="flex justify-end w-full mt-1">
                          <span className="text-xs text-gray-500">
                            {descriptionLengths[index] || hotelDescriptions[index]?.length || displayHotel?.description?.length || 0} / 1000
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="w-full lg:w-80 flex-shrink-0">
                      <InputImage
                        title="Hotel Picture"
                        required={true}
                        photo={
                          hotelImagePreviews[index] !== undefined
                            ? hotelImagePreviews[index] || undefined
                            : displayHotel?.image || undefined
                        }
                        setImage={(image) =>
                          handleImageSet(image, index, false)
                        }
                        maxsize={25}
                        width={412}
                        height={412}
                        extension=".jpg, .png, .gif"
                        adaptiveShape={true}
                        error={validationErrors[index]?.image || false}
                        errorMsg={
                          validationErrors[index]?.image
                            ? "This field is necessary"
                            : undefined
                        }
                      />
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row gap-6 w-full">
                    <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <Input
                          title="Room Type"
                          required={false}
                          name={`hotel-room-type-${index}`}
                          value={hotelRoomTypes[index] ?? (displayHotel as any)?.roomType ?? ""}
                          onChange={(e) =>
                            handleHotelRoomTypeChange(index, e.target.value)
                          }
                          error={false}
                        />
                      </div>
                      <div>
                        <Input
                          title="Room Rate"
                          required={false}
                          name={`hotel-room-rate-${index}`}
                          value={hotelRoomRates[index] ?? (displayHotel as any)?.roomRate ?? ""}
                          onChange={(e) =>
                            handleHotelRoomRateChange(index, e.target.value)
                          }
                          error={false}
                        />
                      </div>
                    </div>
                    <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-2.5 self-stretch items-start">
                      <label className="inputLabel text-gray-font">
                        Currency
                      </label>
                      <div className="relative w-full">
                        <select
                          value={hotelCurrencies[index] ?? (displayHotel as any)?.currency ?? ""}
                          onChange={(e) => handleHotelCurrencyChange(index, e.target.value)}
                          className="w-full p-3 bg-[#F4F4F4] text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none pr-10 border border-[#F4F4F4] leading-normal h-[55px] box-border"
                        >
                          <option value="">Select One</option>
                          {CURRENCY_OPTIONS.map((currency) => (
                            <option key={currency} value={currency}>
                              {currency}
                            </option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                           <ChevronDown
                          className="fill-gray-font"
                          style={{ width: "14px", height: "14px" }}
                        />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row justify-start items-center gap-4 w-full pt-4">
                    <LegacyButton
                      text={
                        displayHotel?.primary ? "REMOVE PRIMARY HOTEL" : "REMOVE HOTEL"
                      }
                      icon={
                        <img
                          src={DeleteTrashIcon}
                          alt="Delete"
                          className="w-5 h-5 ml-2"
                        />
                      }
                      color="delete"
                      style="outlined"
                      size="small"
                      content="textIcon"
                      iconOrder="textFirst"
                      onClick={() => handleRemoveHotel(index)}
                    />
                  </div>
                  {index < sortedHotels.length - 1 && <HotelFormSeparator />}
                </div>
              );
            });
            })()
          ) : (
            <div className="text-gray-500 text-center py-8">
              No accommodation information available.
            </div>
          )}
          {sortedHotels.length > 0 && <HotelFormSeparator />}
          {newHotelIds.map((newHotelId, formIndex) => (
            <div key={newHotelId} className="space-y-6 mt-6">
              <div className="flex flex-col lg:flex-row gap-6">
                <div className="flex-1 space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input
                        title="Hotel Name"
                        required={true}
                        name={`new-hotel-name-${newHotelId}`}
                        value={newHotelNames[newHotelId] ?? ""}
                        onChange={(e) =>
                          handleNewHotelNameChange(newHotelId, e.target.value)
                        }
                        error={
                          newHotelValidationErrors[newHotelId]?.name || false
                        }
                        errorMsj={
                          newHotelValidationErrors[newHotelId]?.name
                            ? "The Hotel Name is required."
                            : undefined
                        }
                      />
                    </div>
                    <div>
                      <Input
                        title="Address"
                        required={true}
                        name={`new-hotel-address-${newHotelId}`}
                        value={newHotelAddresses[newHotelId] ?? ""}
                        onChange={(e) =>
                          handleNewHotelAddressChange(newHotelId, e.target.value)
                        }
                        error={
                          newHotelValidationErrors[newHotelId]?.address || false
                        }
                        errorMsj={
                          newHotelValidationErrors[newHotelId]?.address
                            ? "The Address is required."
                            : undefined
                        }
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input
                        title="Website Link"
                        required={true}
                        name={`new-hotel-website-${newHotelId}`}
                        value={newHotelWebsiteLinks[newHotelId] ?? ""}
                        onChange={(e) =>
                          handleNewHotelWebsiteLinkChange(
                            newHotelId,
                            e.target.value
                          )
                        }
                        error={
                          newHotelValidationErrors[newHotelId]?.websiteLink ||
                          false
                        }
                        errorMsj={
                          newHotelValidationErrors[newHotelId]?.websiteLink
                            ? "The Website Link is required."
                            : undefined
                        }
                      />
                    </div>
                    <div>
                      <Input
                        title="Hotel Reservation Link"
                        required={false}
                        name={`new-hotel-reservation-${newHotelId}`}
                        value={newHotelReservationLinks[newHotelId] ?? ""}
                        onChange={(e) =>
                          handleNewHotelReservationLinkChange(
                            newHotelId,
                            e.target.value
                          )
                        }
                        error={false}
                      />
                    </div>
                  </div>

                  <div>
                    <Input
                      title="Section Title"
                      required={false}
                      name={`new-hotel-section-title-${newHotelId}`}
                      value={newHotelSectionTitles[newHotelId] ?? ""}
                      onChange={(e) =>
                        handleNewHotelSectionTitleChange(
                          newHotelId,
                          e.target.value
                        )
                      }
                      error={false}
                    />
                  </div>

                  <div className="flex flex-col gap-2.5 self-stretch items-start">
                    <label className="inputLabel text-gray-font">
                      Hotel Description
                    </label>
                    <textarea
                      value={newHotelDescriptions[newHotelId] ?? ""}
                      rows={4}
                      maxLength={1000}
                      onChange={(e) =>
                        handleNewHotelDescriptionChange(
                          newHotelId,
                          e.target.value
                        )
                      }
                      className="w-full px-3 py-2 bg-[#F5F5F5] text-gray-900 min-h-[120px] focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                    />
                    <div className="flex justify-end w-full mt-1">
                      <span className="text-xs text-gray-500">
                        {newHotelDescriptionLengths[newHotelId] || newHotelDescriptions[newHotelId]?.length || 0} / 1000
                      </span>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-80 flex-shrink-0">
                  <InputImage
                    title="Hotel Picture"
                    required={true}
                    photo={
                      newHotelImagePreviews[newHotelId] ||
                      newHotelImages[newHotelId] ||
                      undefined
                    }
                    setImage={(image) =>
                      handleImageSet(image, newHotelId, true)
                    }
                    maxsize={25}
                    width={412}
                    height={412}
                    extension=".jpg, .png, .gif"
                    adaptiveShape={true}
                    error={newHotelValidationErrors[newHotelId]?.image || false}
                    errorMsg={
                      newHotelValidationErrors[newHotelId]?.image
                        ? "This field is necessary"
                        : undefined
                    }
                  />
                </div>
              </div>

              <div className="flex flex-col lg:flex-row gap-6 w-full">
                <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Input
                      title="Room Type"
                      required={false}
                      name={`new-hotel-room-type-${newHotelId}`}
                      value={newHotelRoomTypes[newHotelId] ?? ""}
                      onChange={(e) =>
                        handleNewHotelRoomTypeChange(newHotelId, e.target.value)
                      }
                      error={false}
                    />
                  </div>
                  <div>
                    <Input
                      title="Room Rate"
                      required={false}
                      name={`new-hotel-room-rate-${newHotelId}`}
                      value={newHotelRoomRates[newHotelId] ?? ""}
                      onChange={(e) =>
                        handleNewHotelRoomRateChange(newHotelId, e.target.value)
                      }
                      error={false}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-2.5 self-stretch items-start">
                  <label className="inputLabel text-gray-font">Currency</label>
                  <div className="relative w-full">
                    <select
                      value={newHotelCurrencies[newHotelId] ?? ""}
                      onChange={(e) => handleNewHotelCurrencyChange(newHotelId, e.target.value)}
                      className="w-full p-3 bg-[#F4F4F4] text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none pr-10 border border-[#F4F4F4] leading-normal h-[55px] box-border"
                    >
                      <option value="">Select One</option>
                      {CURRENCY_OPTIONS.map((currency) => (
                        <option key={currency} value={currency}>
                          {currency}
                        </option>
                      ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <ChevronDown
                        className="fill-gray-font"
                        style={{ width: "14px", height: "14px" }}
                  />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-start items-center gap-4 w-full pt-4">
                <LegacyButton
                  text="REMOVE HOTEL"
                  icon={
                    <img
                      src={DeleteTrashIcon}
                      alt="Delete"
                      className="w-5 h-5 ml-2"
                    />
                  }
                  color="delete"
                  style="outlined"
                  size="small"
                  content="textIcon"
                  iconOrder="textFirst"
                  onClick={() => handleRemoveNewHotel(newHotelId)}
                />
              </div>
              {formIndex < newHotelIds.length - 1 && <HotelFormSeparator />}
            </div>
          ))}
          {newHotelIds.length > 0 && (
            <div className="w-full border-b border-t border-2 border-[#F6F6F6] my-6"></div>
          )}
          <div className="flex justify-start w-full">
            <LegacyButton
              text="ADD HOTEL"
              icon={
                <div className="save-icon-white ml-2">
                  <SaveChanges />
                </div>
              }
              color="accent"
              style="filled"
              size="small"
              content="textIcon"
              iconOrder="textFirst"
              onClick={handleAddNewHotel}
            />
          </div>
          {(sortedHotels.length > 0 || newHotelIds.length > 0) && (
            <div className="flex flex-col sm:flex-row justify-end items-center gap-4 w-full py-6 px-4 mt-6 border-t border-2 border-[#F4F4F4]">
              <LegacyButton
                text="Cancel"
                icon={
                  <Close className="w-5 h-5 [&>svg>path]:fill-current ml-2" />
                }
                color="neutral"
                style="outlined"
                size="small"
                content="textIcon"
                iconOrder="textFirst"
                onClick={handleCancelAllHotels}
              />
              <LegacyButton
                text="SAVE ALL HOTELS"
                icon={
                  <div className="save-icon-white ml-2">
                    <SaveChanges />
                  </div>
                }
                color="accent"
                style="filled"
                size="small"
                content="textIcon"
                iconOrder="textFirst"
                onClick={handleSaveAllHotels}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}
